<div class="keep-alive-modal" role="alert" data-testid="keep-alive-modal">
    <h3>
        {{ 'keepAliveModal.title' | apContent }}
    </h3>
    <div id="keepAliveModalDescription" class="ap-margin-bottom-4 ap-display-block">
        {{ 'keepAliveModal.content' | apContent: { timeLeft: timeLeft?.toString() } }}
    </div>
    <div role="timer" aria-atomic="true" aria-live="polite" class="ap-sr-only">
        @if (timeLeft % 10 === 0) {
            <span>{{ 'keepAliveModal.content' | apContent: { timeLeft: timeLeft?.toString() } }}</span>
        }
    </div>
    <ap-button data-bb="continueSession" (onClick)="accept()">
        {{ 'keepAliveModal.continueSession' | apContent }}
    </ap-button>
    <ap-button data-bb="endSession" (onClick)="decline()" variant="secondary">
        {{ 'keepAliveModal.endSession' | apContent }}
    </ap-button>
</div>
